<template>
  <section>
    <h2>News</h2>
    <div
      class="d-flex align-items-center justify-content-start my-4 row no-gutters"
    >
      <!-- Metéo -->
      <div
        class="col-3 col-sm-2 order-3 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalSiteMeteo = !modalSiteMeteo"
          type="button"
          class="btn btn-primary btn_repertoire"
        >
          <font-awesome-icon icon="cloud-sun-rain" size="2x" />
        </button>

        <span class="text-primary span_repertoire text-wrap">Météo</span>
        <b-modal
          v-model="modalSiteMeteo"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Météo"
          content-class="modalSite"
        >
          <iframe
            class="modalPdf"
            src="https://www.ventusky.com/?p=48.17;2.10;6&l=temperature-2m&w=0DAKtpv2b"
            allowfullscreen
          ></iframe>
        </b-modal>
      </div>

      <!-- Trafic -->
      <div
        class="col-3 col-sm-2 order-4 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalSiteTrafic = !modalSiteTrafic"
          type="button"
          class="btn btn-dark btn_repertoire"
        >
          <font-awesome-icon icon="car" size="2x" />
        </button>
        <span class="text-dark span_repertoire text-wrap">Trafic</span>

        <b-modal
          v-model="modalSiteTrafic"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Trafic routier"
          content-class="modalSite"
        >
          <iframe
            class="modalPdf"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105229.0627758809!2d2.2715760484576792!3d48.85571145459576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e1f06e2b70f%3A0x40b82c3688c9460!2sParis!5e0!3m2!1sfr!2sfr!4v1562660918664!5m2!1sfr!2sfr/data=!5m1!1e1"
            width="800"
            height="600"
            frameborder="0"
            style="border:0"
            allowfullscreen
          ></iframe>
        </b-modal>
      </div>

      <!-- Bulletin de salaire -->
      <div
        class="col-3 col-sm-2 order-1 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalNotes = !modalNotes"
          type="button"
          class="btn btn-info btn_repertoire"
        >
          <font-awesome-icon icon="file-alt" size="2x" />
        </button>
        <span class="text-info span_repertoire text-wrap"
          >Bulletin de salaire</span
        >

        <b-modal
          v-model="modalNotes"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Bulletin de salaire"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            type="application/pdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/news/Bulletin_salaire.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Congé -->
      <div
        class="col-3 col-sm-2 order-2 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalConge = !modalConge"
          type="button"
          class="btn btn-secondary btn_repertoire"
        >
          <font-awesome-icon icon="umbrella-beach" size="2x" />
        </button>
        <span class="text-secondary span_repertoire text-wrap">Congé</span>

        <b-modal
          v-model="modalConge"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Congé"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            type="application/pdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/news/cong%c3%a9s.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Note de Service -->
      <div
        class="col-3 col-sm-2 order-5 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalNoteService = !modalNoteService"
          type="button"
          class="btn btn-danger btn_repertoire"
        >
          <font-awesome-icon icon="user-shield" size="2x" />
        </button>
        <span class="text-danger span_repertoire text-wrap"
          >Note de service</span
        >

        <b-modal
          v-model="modalNoteService"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Note de service"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            type="application/pdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/news/note%20de%20service%20s%c3%a9curisation%20des%20sites.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!--Groupes d'expression -->
      <div
        class="col-3 col-sm-2 order-6 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalGroupe = !modalGroupe"
          type="button"
          class="btn btn-success btn_repertoire"
        >
          <font-awesome-icon icon="users" size="2x" />
        </button>
        <span class="text-success span_repertoire text-wrap"
          >Groupe d'expression</span
        >

        <b-modal
          v-model="modalGroupe"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Groupe d'expression"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            type="application/pdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/news/affiche-expression.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!--CE -->
      <div
        class="col-3 col-sm-2 order-8 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button disabled type="button" class="btn btn-primary btn_repertoire">
          <font-awesome-icon icon="hands-helping" size="2x" />
        </button>
        <span class="text-primary span_repertoire text-wrap"
          >Comité d'entreprise</span
        >
      </div>
      <!-- Kisdis -->
      <div
        class="col-3 col-sm-2 order-7 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <!-- <button @click="modalE_Learning = !modalE_Learning" type="button"
                    class="btn btn-primary btn_boutique " disabled>
                    <font-awesome-icon icon="video" size="2x" />
        </button>-->
        <a href="#" @click="modalKidis = !modalKidis">
          <img
            class="btn_repertoire rounded border border-primary"
            src="../../assets/logo.png"
            alt
          />
        </a>
        <span class="text-primary span_repertoire">Kisdis</span>
        <b-modal
          v-model="modalKidis"
          centered
          hide-footer
          scrollable
          title="Kisdiss"
        >
          <ul class="list-group">
            <li class="list-group-item text-center">
              <span @click="modalKidisCatalogue = !modalKidisCatalogue"
                >Catalogue</span
              >
            </li>
            <b-modal
              v-model="modalKidisCatalogue"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Catalogue Kisdis"
            >
              <iframe
                class="modalPdf"
                src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/news/04-CATALOGUE%20KIS%20DIS.pdf&embedded=true"
              ></iframe>
            </b-modal>

            <li class="list-group-item text-center">
              <span @click="modalKidisPlaquette = !modalKidisPlaquette"
                >Plaquette</span
              >
            </li>

            <b-modal
              v-model="modalKidisPlaquette"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Plaquette Kisdis"
            >
              <iframe
                class="modalPdf"
                src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/news/PLAQUETTE%20KISDIS-200319.pdf&embedded=true"
              ></iframe>
            </b-modal>
          </ul>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      modalNotes: false,
      modalOffre: false,
      modalSiteTrafic: false,
      modalSiteMeteo: false,
      modalConge: false,
      modalNoteService: false,
      modalGroupe: false,
      modalKidis: false,
      modalKidisCatalogue: false,
      modalKidisPlaquette: false
    };
  }
};
</script>

<style>
.modalSite {
  width: 100vw !important;
  height: 100vh !important;
}
.btn_boutique {
  width: 4.5rem;
  height: 4.5rem;
  /* Centrer et aligner image dans button */
  display: flex !important;
  justify-content: space-around !important;
  align-items: center !important;
}
</style>
